@if (token) {
  <pay-login-password-reset (passwordResetDone)="routeToNextPage()" [token]="this.token" />
}
